/* global document */

import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
import { PropertySkeleton } from '../abstracts/PropertySkeleton'


/**
 * Class for managing property blocks (both on listings page and in similar properties section)
 * 
 * @todo move into separate file
 *
 */
export class PropertyBlock extends PropertySkeleton {


	nodeSignInPopup
	nodeSignInPopupClose
	nodeSignInPopupTrigger = []

	nodeRequestInfoPopup
	nodeRequestInfoPopupClose
	nodeRequestInfoPopupTriggers = []

	imageSlider

	initted = false


	/**
	 * Function description
	 *
	 * @param {HTMLElement} node
	 */
	constructor( node ) {
		super( node )

		this.nodeSignInPopup = this.node.querySelector( '.js-sign-in-popup' )
		this.nodeSignInPopupClose = this.node.querySelector( '.js-sign-in-popup-close' )
		this.nodeSignInPopupTrigger = this.node.querySelectorAll( '.js-sign-in-popup-trigger' )

		this.nodeRequestInfoPopup = this.node.querySelector( '.js-request-info-popup' )
		this.nodeRequestInfoPopupClose = this.node.querySelector( '.js-request-info-popup-close' )
		this.nodeRequestInfoPopupTrigger = this.node.querySelectorAll( '.js-request-info-popup-trigger' )
	}
		
		
	/**
	 * Initialize basic class functions
	 *
	 * @return {void}
	 */
	init() {
		// don't apply if already applied
		if( this.initted ) {
			return false
		}
		this.initted = true

		this.initImageSlider()
		this.initEventListeners()
	}


	/**
	 * Attach event listeners
	 *
	 * @return {void}
	 */
	initEventListeners() {

		// add/remove property from favorites (only for logged in users)
		if( this.nodeFavoriteBtn ) {
			this.nodeFavoriteBtn.addEventListener( 'click', this.handleFavoriteBtnClick.bind( this ) )
		}

		this.nodeRequestInfoPopupTrigger.forEach( node => {
			node.addEventListener( 'click', this.showRequestPopup.bind( this ) )
		})

		if( this.nodeRequestInfoPopup && this.nodeRequestInfoPopupClose ) {
			this.nodeRequestInfoPopupClose.addEventListener( 'click', this.closeRequestPopup.bind( this ) )
		}

		this.nodeSignInPopupTrigger.forEach( node => {
			node.addEventListener( 'click', this.showSignInPopup.bind( this ) )
		})

		if( this.nodeSignInPopup && this.nodeSignInPopupClose ) {
			this.nodeSignInPopupClose.addEventListener( 'click', this.closeSignInPopup.bind( this ) )
		}
	}


	/**
	 * Create image slider for property
	 * 
	 * @todo throw into abstract?
	 *
	 * @return {void}
	 */
	initImageSlider() {
		const slider = this.node.querySelector( '.js-property-image-slider' )

		if( !slider ) {
			return
		}

		const nodeBtnNext = slider.querySelector( '.js-property-slider-btn-next' )
		const nodeBtnPrev = slider.querySelector( '.js-property-slider-btn-prev' )
		const nodePagination = this.node.querySelector( '.js-property-slider-pagination' )

		const useLoop = 1 < slider.querySelectorAll( '.swiper-slide' ).length

		this.imageSlider = new Swiper( slider, {
			loop: useLoop,
			spaceBetween: 16,
			navigation: {
				nextEl: nodeBtnNext,
				prevEl: nodeBtnPrev,
			},
			pagination: {
				el: nodePagination,
				type: 'fraction',
			},
			modules: [ Navigation, Pagination ],
		})
	}


	/**
	 * Show popup with listing agent form
	 *
	 * @return {void}
	 */
	showRequestPopup() {
		if( !this.nodeRequestInfoPopup ) {
			return
		}

		document.body.classList.add( 'popup-is-visible' )

		this.nodeRequestInfoPopup.showModal()
	}


	/**
	 * Close popup with listing agent form
	 *
	 * @return {void}
	 */
	closeRequestPopup() {
		if( !this.nodeRequestInfoPopup ) {
			return
		}

		document.body.classList.remove( 'popup-is-visible' )

		this.nodeRequestInfoPopup.close()
	}

	/**
	 * Show popup with listing agent form
	 *
	 * @return {void}
	 */
	showSignInPopup() {
		if( !this.nodeSignInPopup ) {
			return
		}

		document.body.classList.add( 'popup-is-visible' )

		this.nodeSignInPopup.showModal()
	}


	/**
	 * Close popup with listing agent form
	 *
	 * @return {void}
	 */
	closeSignInPopup() {
		if( !this.nodeSignInPopup ) {
			return
		}

		document.body.classList.remove( 'popup-is-visible' )

		this.nodeSignInPopup.close()
	}

}